/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ApplySpaceTemplate,
  EntityId,
  Expression,
  List,
  SiteSpace,
  SiteSpaceMovePosition,
  SiteSpacePath,
  SiteTitle,
} from "./data-contracts";

/**
 * @description Pass an existing space ID to link it, or pass `null` to create and link a new space. New spaces start with a blank page unless a template is provided or `empty` is `true`, which creates the space with no page at all (use it when you are about to add the pages yourself).
 * @tags site-spaces
 * @name AddSpaceToSite
 * @summary Add a space to a site as a content source
 * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces
 * @secure
 */

// @ts-ignore
export const addSpaceToSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Pass the ID of an existing space or `null` to create a new space. */
    spaceId: string | null;
    /** Template for the new space when `spaceId` is `null`. Templates that provision organization-level resources, such as OpenAPI specifications, are not supported by this site-scoped operation. */
    template?: ApplySpaceTemplate;
    /** ID of the section to add the space to. If not provided, the space will be added to the default section or at the root level if the site has no sections. */
    sectionId?: string;
    /**
     * Whether the site space should be created as draft. Defaults to false. Editors can set this to true to create draft content on a non-empty site. Creating live content and adding the first content require Creator permission.
     * @default false
     */
    draft?: boolean;
    /** Custom home page within an existing space, rendered at the site space's path root instead of the space's default landing page. Providing it when `spaceId` is `null` returns a 400 error. */
    pageId?: string | null;
    /**
     * Create the new space without any content, not even a blank page. Useful when the content is about to be populated, for example by an import. Only valid when `spaceId` is `null` and no template is provided.
     * @default false
     */
    empty?: boolean;
    /** Site-specific title override for the variant. Also used as the space title when `spaceId` is `null` and no template is provided. */
    title?: SiteTitle;
  };
  RequestHeaders: {
    /** Control whether a successful response includes the updated resource representation. */
    prefer?: "return=minimal" | "return=representation";
  };
  ResponseBody: SiteSpace | undefined;
  ResponseStatusCode: 201 | 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces",
  method: "post",
  streaming: false,
  tags: ["site-spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of site spaces — the links between a site and its content source spaces. Each site space can be a language variant or content version within a section. Use the default filter to retrieve only the primary site space, or omit it to get all linked spaces including drafts. Members with access only to individual spaces receive only site-space links for those spaces.
 * @tags site-spaces, critical
 * @name ListSiteSpaces
 * @summary List all spaces linked to a site as content sources
 * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces
 * @secure
 */

// @ts-ignore
export const listSiteSpaces: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If true, only the default site space will be returned. If false, only the non-default site spaces are returned. If undefined, all site spaces are returned. */
    default?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteSpace[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces",
  method: "get",
  streaming: false,
  tags: ["site-spaces", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Updates the configuration of a site space. Use this to remap a site space to a different space, hide it from navigation, or promote it from draft to live.
 * @tags site-spaces
 * @name UpdateSiteSpaceById
 * @summary Update a space linked to a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}
 * @secure
 */

// @ts-ignore
export const updateSiteSpaceById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Path to the space on the site */
    path?: SiteSpacePath;
    /** Conditional expression used to evaluate whether the site space should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
    condition?: Expression | null;
    /** Custom home page within the space, rendered at the site space's path root instead of the space's default landing page. If not set, the page will remain unchanged unless spaceId is changed, in which case the custom home page will be removed. If set to null, the custom home page will be removed. */
    pageId?: string | null;
    /** The content that this site space points to. If not set, the space will remain unchanged. */
    spaceId?: string;
    /** Whether the site space is hidden. If true, the site space will not be shown in the site's navigation. If not set, the hidden state will remain unchanged. If set to false, the site space will be shown in site navigation. */
    hidden?: boolean;
    /** Whether the site space should be kept in draft mode. Setting it to true makes the site space draft. Setting it to false makes the site space live. */
    draft?: boolean;
  };
  RequestHeaders: {
    /** Control whether a successful response includes the updated resource representation. */
    prefer?: "return=minimal" | "return=representation";
  };
  ResponseBody: SiteSpace | undefined;
  ResponseStatusCode: 200 | 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}",
  method: "patch",
  streaming: false,
  tags: ["site-spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-spaces
 * @name DeleteSiteSpaceById
 * @summary Delete a site space
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}
 * @secure
 */

// @ts-ignore
export const deleteSiteSpaceById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}",
  method: "delete",
  streaming: false,
  tags: ["site-spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a full copy of the space linked by the specified site space. When the site space is the only variant in a section, the copy is placed in a new sibling section. Otherwise, it is added as a variant under the same parent. Prefer this operation over duplicateSpace whenever the request originates from a site or needs to preserve site placement.
 * @tags site-spaces, spaces
 * @name DuplicateSiteSpace
 * @summary Duplicate a space in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/duplicate
 * @secure
 */

// @ts-ignore
export const duplicateSiteSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /**
         * Whether the duplicated site space and any new section should be created as drafts.
         * @default false
         */
        draft?: boolean;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: SiteSpace;
  ResponseStatusCode: 201;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/duplicate",
  method: "post",
  streaming: false,
  tags: ["site-spaces", "spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-spaces
 * @name MoveSiteSpace
 * @summary Move a site space to a new position. (Deprecated) use sortSiteStructure instead.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/move
 * @deprecated
 * @secure
 */

// @ts-ignore
export const moveSiteSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /** The position where to move the site space. When not provided the site space is moved at the end of the site. */
        position?: SiteSpaceMovePosition;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: SiteSpace;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/move",
  method: "post",
  streaming: false,
  tags: ["site-spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};
